<div class="date-range-container" [class.disabled]="disabled">
  <label class="form-control-label" *ngIf="label">{{ label }}</label>

  <div class="dp-hidden position-absolute">
    <div class="input-group">
      <input
        name="datepicker"
        class="form-control"
        ngbDatepicker
        #datepicker="ngbDatepicker"
        [autoClose]="'outside'"
        (dateSelect)="onDateSelection($event)"
        [displayMonths]="2"
        [dayTemplate]="t"
        outsideDays="hidden"
        [startDate]="displayStartDate"
        datepickerClass="date-range-picker-popup"
        tabindex="-1"
        container="body"
        (closed)="onDateSelectionFinished()"
        [disabled]="disabled"
      />
      <ng-template #t let-date let-focused="focused">
        <span
          class="custom-day"
          [class.focused]="focused"
          [class.range]="isRange(date)"
          [class.faded]="isHovered(date) || isInside(date)"
          [class.disabled-date]="isDisabledDate(date)"
          [style.pointer-events]="isDisabledDate(date) ? 'none' : 'auto'"
          (mouseenter)="!isDisabledDate(date) && (hoveredDate = date)"
          (mouseleave)="hoveredDate = null"
        >
          {{ date.day }}
        </span>
      </ng-template>
    </div>
  </div>

  <div class="input-group">
    <input
      #dpFromDate
      class="form-control"
      placeholder="dd/mm/aaaa - dd/mm/aaaa"
      name="dpFromDate"
      [value]="getDateText()"
      (input)="fromDate = validateInput(fromDate, dpFromDate.value)"
      autocomplete="off"
      [readOnly]="true"
      [attr.disabled]="disabled ? true : null"
      [ngbTooltip]="tooltip"
      [disableTooltip]="!tooltip"
      container="body"
    />
    <div class="input-group-append">
      <button
        *ngIf="fromDate || toDate"
        class="btn btn-outline-secondary btn-small feather icon-x"
        (click)="clear()"
        type="button"
        [disabled]="disabled"
        rippleEffect
        title="Limpar data"
      ></button>
      <button
        class="btn btn-outline-secondary btn-small feather icon-calendar"
        (click)="!disabled && datepicker.toggle()"
        type="button"
        [disabled]="disabled"
        rippleEffect
        title="Selecionar data"
      ></button>
    </div>
  </div>
</div>
